var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content"
  }, [_vm.$store.state.utils.configuration.enableNewRecipeDeclinedModal ? _c('div', [_c('div', {
    staticClass: "new-modal-error-icon"
  }, [_vm._v("!")]), _c('h2', {
    staticClass: "new-modal-title"
  }, [_vm._v(_vm._s(_vm.translations.moderationHeader))]), _c('p', {
    staticClass: "new-modal-description"
  }, [_vm._v("\n      " + _vm._s(_vm.translations.moderationDescription) + "\n    ")])]) : _c('h5', {
    staticClass: "text-center subheader"
  }, [_vm._v("\n    " + _vm._s(_vm.translations.recipeDeclinedSubHeader1)), _c('br'), _vm._v("\n    " + _vm._s(_vm.translations.recipeDeclinedSubHeader2) + "\n  ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }